import {InjectionToken, ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {InjectionRootComponent} from "./injection-root/injection-root.component";
import {defaultConfig, INJECTION_MODULE_TOKEN} from "./exports";
import {HistoryComponent} from "./history/history.component";
import {TranslateModule} from "@ngx-translate/core";
import {MaterialModule} from "../../material-module";
import {RouterModule} from "@angular/router";
import {HistoryDetailsComponent} from './history-details/history-details.component';
import {RoutingModule} from "./injection.routing";
import {ChartBlocksModule} from "../chartBlocks/chartBlocks.module";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {HttpClientModule} from "@angular/common/http";
import {ApiService} from "./api.service";
import {ModalComponent} from "./modal/modal.component";
import {DragDropDirective} from "./drag-drop.directive";
import { UploadFileComponent } from './upload-file/upload-file.component';
import { MasseComponent } from './masse/masse.component';
import { ReportingComponent } from './reporting/reporting.component';
import { CollaboratorsComponent } from './masse/collaborators/collaborators.component';
import { ViewblocksComponent } from './viewblocks/viewblocks.component';
import {VirtualScrollModule} from "../virtual-scroll/virtual-scroll.module";
import {MatAutocompleteModule} from '@angular/material';
import {ModalTadHoursComponent} from './modal-tad-hours/modal-tad-hours.component';
import {NgxPermissionsModule} from 'ngx-permissions';
import {ModalCommentComponent} from './modal-comment/modal-comment.component';

@NgModule({
  declarations: [
    ModalComponent,
    ModalTadHoursComponent,
    ModalCommentComponent,
    InjectionRootComponent,
    HistoryComponent,
    HistoryDetailsComponent,
    DragDropDirective,
    UploadFileComponent,
    MasseComponent,
    ReportingComponent,
    CollaboratorsComponent,
    ViewblocksComponent
  ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        MaterialModule,
        TranslateModule.forChild(),
        RoutingModule,
        ChartBlocksModule,
        NgxPermissionsModule.forRoot(),
        VirtualScrollModule,
        MatAutocompleteModule,
    ],
  providers: [ApiService],
  entryComponents: [CollaboratorsComponent, UploadFileComponent, HistoryDetailsComponent, HistoryComponent, InjectionRootComponent,ModalComponent,ModalTadHoursComponent,ModalCommentComponent],
  exports: [HistoryDetailsComponent, HistoryComponent, InjectionRootComponent, ModalComponent,ModalTadHoursComponent, RouterModule, ModalCommentComponent]
})
export class InjectionModule {

  public static forRoot(config = defaultConfig): ModuleWithProviders {
    return {
      ngModule: InjectionModule,
      providers: [
        {provide: 'inject-config', useValue: config},
      ],
    };
  }
}




// WEBPACK FOOTER //
// ./src/app/modules/injection/injection.module.ts